/**
 * Creates location form with hidden input values appropriately set
 * @param {String} formId
 * @param {Object} aliases Aliases for the names of the hidden fields
 */
export default function createLocationForm(formId, aliases = {}) {
  let postForm;
  const fields = {};

  function getForm() {
    if (!postForm) {
      postForm = document.getElementById(formId);
    }
    return postForm;
  }

  // You need to call this function whenever you override
  // submit in your own module
  function attachHiddenFields() {
    Object.keys(fields).forEach(key => {
      createHiddenField(aliases[key] ? aliases[key] : key, fields[key]);
    });
  }

  function createHiddenField(name, value = '') {
    const field = document.createElement('input');
    field.setAttribute('type', 'hidden');
    field.setAttribute('name', name);
    field.value = value;
    getForm().appendChild(field);
    return field;
  }

  function submit() {
    attachHiddenFields();
    getForm().submit();
  }

  function setLocation({
    lat,
    lng,
    vicinity,
    administrative_area_level_1: administrativeArea,
    country,
    formatted_address: formattedAddress,
  }) {
    fields.latitude = lat;
    fields.longitude = lng;
    fields.vicinity = vicinity;
    fields.administrative_area = administrativeArea;
    fields.country = country;
    fields.full_address = formattedAddress;
  }

  return {
    createHiddenField,
    submit,
    setLocation,
    attachHiddenFields,
    fields,
  };
}
